import * as audioVideoReceiptActions from '../../actions/audio-video/receipt';
import * as audioVideoActions from '../../actions/checkout/audio-video';
import { InmateAccountPayment, InmateAccountPaymentData } from '../../models/InmateAccountPayment';
import { ApiError } from '../../services/api';

export interface IAudioVideoReceiptState {
  receiptEmailAddress?: string
  payment?: InmateAccountPayment
  paymentLoading: boolean
  paymentLoadError?: ApiError
}

const initialState:IAudioVideoReceiptState = {
  paymentLoading: false
};

export function audioVideoReceiptReducer(state: IAudioVideoReceiptState = initialState, action): IAudioVideoReceiptState {
  switch (action.type) {
    case audioVideoReceiptActions.LOAD_PAYMENT_LOADING:
      return {
        ...state,
        payment: null,
        paymentLoading: true,
        paymentLoadError: null
      };

    case audioVideoReceiptActions.LOAD_PAYMENT_FAILURE:
      return {
        ...state,
        payment: null,
        paymentLoading: false,
        paymentLoadError: action.error
      };

    case audioVideoReceiptActions.LOAD_PAYMENT_SUCCESS:
      return {
        ...state,
        payment: action.payment,
        paymentLoading: false,
        paymentLoadError: null
      };

    case audioVideoActions.PAYMENT_SUCCESS:
      const paymentData: InmateAccountPaymentData = action.paymentData;
      return {
        ...state,
        payment: action.payment,
        receiptEmailAddress: paymentData.receiptEmailAddress
      };

    case audioVideoReceiptActions.RESET:
      return initialState;
  }

  return state;
}
